const hasConversationIdValue = (value) =>
  value !== undefined && value !== null && value !== '';

const normalizeConversationId = (value) =>
  hasConversationIdValue(value) ? String(value) : null;

const areSameConversationId = (left, right) => {
  const normalizedLeft = normalizeConversationId(left);
  const normalizedRight = normalizeConversationId(right);

  return (
    normalizedLeft !== null &&
    normalizedRight !== null &&
    normalizedLeft === normalizedRight
  );
};

const isCurrentConversationId = (currentChat, conversationId) =>
  areSameConversationId(currentChat && currentChat.id, conversationId);

export {
  areSameConversationId,
  hasConversationIdValue,
  isCurrentConversationId,
  normalizeConversationId,
};
